module.exports = __webpack_public_path__ + "img/shop.ac0db40c.svg";